module.exports = __webpack_public_path__ + "img/020076.12ea3693.png";